export const userManagementEndpoints = {
  reportsTo: "/user-management/dropdown?type=reportsTo",
  roles: "/user-management/dropdown?type=roles",
  exclusions: "/user-management/dropdown?type=exclusions",
  exclusionValues: "/user-management/dropdown?type=exclusionKey&exclusionTypeKey=",
  users: "/user-management/users",
  emailInUse: "/user-management/users/email-in-use",
  setUserPassword: (userId: string) => `/user-management/users/${userId}/password`,
  cancelInvite: (userId: string) => `/user-management/users/${userId}/cancel-invite`,
  // Cross-tenant: every user in every entity. App-level super admins only.
  userDirectory: "/user-management/users/directory",
  superAdminUsers: "/user-management/users/super-admin",
  superAdminReportsTo: "/user-management/dropdown?type=superAdmin",
  userDropdown: "/dropdown",
  userManagementDropdown: "/user-management/dropdown",
  startImpersonation: "/session-management/impersonation/start",
  endImpersonation: "/session-management/impersonation/end",
};
